import { Box, Heading, Stack, VStack } from "@chakra-ui/react";
import React from "react";
import { ViewControl } from "../ViewControl/ViewControl";
import DateUtil from "../../util/DateUtil";
import { EventFormValues } from "../../forms/Events/EventForm";
import { MembershipFilterSummary } from "../MemberFilterQueryModal/MemberFilterSummary";

interface EventPreviewProps {
  values: EventFormValues;
  memberCount: number | null;
  onMemberFilterQueryChange?: (queryString: string) => void;
}

export const EventPreview: React.FC<EventPreviewProps> = ({
  values,
  memberCount,
  onMemberFilterQueryChange,
}) => {
  // Format dates for display
  const formattedStartDate = DateUtil.getLocalDateOnlyFormatFromString(
    values.eventStartDate
  );
  const formattedEndDate = DateUtil.getLocalDateOnlyFormatFromString(
    values.eventEndDate
  );

  // Calculate event duration
  const startDate = new Date(values.eventStartDate);
  const endDate = new Date(values.eventEndDate);
  let durationText = "-";

  if (values.eventStartDate && values.eventEndDate) {
    const durationDays = Math.ceil(
      (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24)
    );
    durationText = durationDays === 1 ? "1 day" : `${durationDays} days`;
  }

  return (
    <Box
      w="100%"
      p={4}
      border="1px solid"
      borderColor="cherryButtonDark.50"
      borderRadius="md"
    >
      <Stack spacing={6} w="100%">
        <Heading size="md" color="cherryGrey.900">
          Preview
        </Heading>

        <VStack align="start" w="100%">
          <Heading variant="view-heading">Event Details</Heading>
          <VStack align="start" w="100%" spacing={4} pb={6}>
            <ViewControl label="Event Name:" value={values.eventName || "-"} />
            <ViewControl
              label="Event Location:"
              value={values.eventLocation || "-"}
            />
            <ViewControl
              label="Event Timezone:"
              value={values.eventTimezone || "-"}
            />
            <ViewControl label="Event Duration:" value={durationText} />
            <ViewControl
              label="Total Eligible Members:"
              value={
                memberCount !== null ? memberCount.toString() : "Loading..."
              }
            />
          </VStack>
          <Heading variant="view-heading">
            Eligible Members for This Event
          </Heading>
          <MembershipFilterSummary
            queryString={values.memberFilterQuery ?? ""}
            onQueryChange={onMemberFilterQueryChange}
          />
        </VStack>

        <VStack align="start" w="100%">
          <Heading variant="view-heading">Schedule</Heading>
          <VStack align="start" w="100%" spacing={4} pb={6}>
            <ViewControl
              label="Start Date:"
              value={formattedStartDate || "-"}
            />
            <ViewControl label="End Date:" value={formattedEndDate || "-"} />
            <ViewControl
              label="Check-in Start Time:"
              value={DateUtil.formatTimeToAmPm(values.checkInStartTime) || "-"}
            />
            <ViewControl
              label="Check-in End Time:"
              value={DateUtil.formatTimeToAmPm(values.checkInEndTime) || "-"}
            />
          </VStack>
        </VStack>
      </Stack>
    </Box>
  );
};
